import axios from "axios";
import Api from "../../auth/Auth-token";

// import { AuthContext } from 'contexts/ConfigContext';
import { useContext } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";

//......................Post Api With Authorization........................................

export const postApiWithAuthenticated = async (url, params) => {
  const localStore = JSON.parse(localStorage.getItem("login"));
  const token = localStore.logInItem.token;
  try {
    if (token === undefined || token === null || token === "") {
      window.location.replace("/logout");
      return;
    }
    const res = await Api.post(url, params);
    if (res?.data?.statusCode === 401) {
      // Remove user-related details here
      // navigate('/login'); // Redirect to login
      return;
    }
    return res;
  } catch (error) {
    if (error.response?.status === 401) {
      window.location.replace("/logout");

      // Remove user-related details here
      // navigate('/logout'); // Redirect to logout
    } else {
      return error;
    }
  }
};

//......................Get List With Authorization....................................

export const getListWithAuthenticated = async (url) => {
  const localStore = JSON.parse(localStorage.getItem("login"));
  const token = localStore.logInItem.token;
  try {
    if (token === undefined || token === null || token === "") {
      window.location.replace("/logout");
      return;
    }
    const res = await Api.get(url);

    if (res.data.statusCode === 401) {
      // remove user related Details here
      // <Navigate to={<Login />} />;
      return;
    }
    return res;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.clear();

      window.location.replace("/logout");

      // Remove user-related details here
      // navigate('/logout'); // Redirect to logout
    } else {
      return error;
    }
  }
};

export const postApi = async (url, params) => {
  // const localStore = JSON.parse(localStorage.getItem('login'));
  // const token = localStore.logInItem.token;
  try {
    // if (token === undefined || token === null || token === '') {
    //   window.location.replace('/logout');
    //   return;
    // }
    const res = await axios.post(url, params);
    if (res.data.statusCode === 401) {
      // remove user related Details here
      // <Navigate to={<Login />} />;
      return;
    }
    return res;
  } catch (error) {
    if (error.response?.status === 401) {
      window.location.replace("/logout");

      // Remove user-related details here
      // navigate('/logout'); // Redirect to logout
    } else {
      return error;
    }
  }
};
